<template>
  <div v-if="this.enableAccessAuthCreate('E2', this.getUser.pref.select.cauth) === true">
    <v-btn :color="ui.btnColor" flat dark @click="openDialog()"
    v-if="this.data.btnSize === 'flat'">
      <v-icon left>
        add
      </v-icon>
      {{this.data.btnTitle}}
    </v-btn>
    <v-btn :color="ui.bkgdColor" :class="ui.textSubheadingBold" icon dark @click="openDialog()"
      v-else-if="this.data.btnSize === 'iconAdd'">
      <v-icon>
        add
      </v-icon>
    </v-btn>
    <v-btn :color="ui.bkgdColor" :class="ui.textSubheadingBold" icon dark @click="openDialog()"
    v-else>
      <v-icon>
        add
      </v-icon>
    </v-btn>
    <v-dialog v-model="dialog" :max-width="ui.sizeWidthDialogLarge">
      <v-card :color="ui.bkgdColor">
        <v-card-title :class="ui.textTitle">
          <v-layout row>
            <v-icon large left :color="ui.btnColor"> add </v-icon>
            <span :class="ui.textHeadline">
              <div :class="ui.textColor">
                New Engineering Request
              </div>
            </span>
            <v-spacer/>
            <v-icon :color="ui.btnColor"
            v-if="this.engTitlePrefix === 'Facility'"> place </v-icon>
          </v-layout>
        </v-card-title>
        <v-progress-linear :color="ui.btnColor" height="1" value="100"/>
        <v-card-text :class="ui.bkgdColor">
          <v-layout class="text-xs-left ml-3 mr-2 mt-2">
            <div :class="ui.textSubheadingBold">
              {{engTitlePrefix}} {{stepInfo.title}}
            </div>
          </v-layout>
          <v-layout class="text-xs-left ml-3 mr-2 mt-2">
            <div :class="ui.textSubheading">
              {{stepInfo.msg}}
            </div>
          </v-layout>
          <v-form v-model="valid" lazy-validation>
            <v-container :class="ui.bkgdColor" v-if="this.step == 0">
              <v-layout row wrap class="ml-2 mr-2">
                <v-flex xs11>
                  <v-text-field
                  v-model="localForm.title"
                  :rules="mustBeLessThanSmall"
                  prepend-icon="title"
                  hint="engineering request title"
                  persistent-hint
                  required
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row wrap class="ml-2 mr-2">
                <v-flex xs11>
                  <v-select
                    v-model="localForm.dis"
                    :items="engineeringDiscipline"
                    color="wplblue0"
                    prepend-icon="engineering"
                    hint="discipline"
                    persistent-hint
                  >
                  </v-select>
                </v-flex>
              </v-layout>
              <div v-if="this.engAsset.id !== null && this.engAsset.id !== ''">
                <v-layout class="text-xs-left ml-2 mr-2 mt-4">
                  <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                    <v-avatar>
                    <v-icon :color="ui.colorWarning"> emoji_transportation </v-icon>
                    </v-avatar>
                    <div :class="ui.textWarning">
                      Asset
                    </div>
                  </v-chip>
                </v-layout>
                <v-layout row wrap class="ml-3 mr-2 mt-2">
                  <v-flex xs11>
                    <v-text-field
                    :label="engAsset.title"
                    prepend-icon="title"
                    hint="asset name"
                    persistent-hint
                    readonly
                    outline
                    ></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout row wrap class="ml-3 mr-2">
                  <v-flex xs11>
                    <v-text-field
                    :label="engAsset.id"
                    prepend-icon="fingerprint"
                    hint="asset tag"
                    persistent-hint
                    readonly
                    outline
                    ></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout row :class="ui.textSubheading"
                v-if="this.getCurrentPage !== '/registerlist'">
                  <v-spacer/>
                  <Append :data="{tag: 'A1'}"/>
                </v-layout>
              </div>
            </v-container>

            <v-container :class="ui.bkgdColor" v-if="this.step == 1">
              <v-layout row wrap class="ml-2 mr-2"
              v-if="this.engTitlePrefix !== 'Facility'">
                <v-flex xs11>
                  <v-select
                    v-model="localForm.reach"
                    :items="reachBusinessOperationsOptions"
                    color="wplblue0"
                    prepend-icon="filter_list"
                    hint="study level"
                    persistent-hint
                  >
                  </v-select>
                </v-flex>
              </v-layout>
              <v-layout row wrap class="ml-2 mr-2">
                <v-flex xs11>
                  <v-select
                    v-model="localForm.type"
                    :items="engineeringRequestTypeOptions"
                    color="wplblue0"
                    prepend-icon="grid_view"
                    hint="request type"
                    persistent-hint
                  >
                  </v-select>
                </v-flex>
              </v-layout>
              <v-layout row wrap class="ml-1 mr-1 mt-4">
                <v-flex xs10 offset-xs1>
                  <v-textarea
                  :color="ui.textColor"
                  :background-color="ui.btnColor"
                  v-model="localForm.des"
                  label="engineering description"
                  :disabled="false"
                  :outline="true"
                  :rules="ruleMustBeNotUndefinedANDLessThan2000"
                  hint="engineering requirements"
                  auto-grow
                  persistent-hint
                  ></v-textarea>
                </v-flex>
              </v-layout>
            </v-container>

            <v-container :class="ui.bkgdColor" v-if="this.step == 2">
              <v-layout class="text-xs-left ml-2 mr-2 hidden-xs-only">
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <v-avatar>
                  <v-icon> account_balance </v-icon>
                  </v-avatar>
                  Company
                </v-chip>
                <v-spacer/>
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  {{getUser.pref.select.cname}}
                </v-chip>
              </v-layout>
              <div v-if="this.engTitlePrefix === 'Facility'">
                <v-layout class="text-xs-left ml-2 mr-2 hidden-xs-only">
                  <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                    <v-avatar>
                    <v-icon> place </v-icon>
                    </v-avatar>
                    Facility
                  </v-chip>
                  <v-spacer/>
                  <v-chip :color="ui.bkgdColor" :class="ui.textSubheading"
                  v-if="this.getUser.pref.select.fdid !== ''">
                    {{getUser.pref.select.fname}}
                  </v-chip>
                  <v-chip :color="ui.bkgdColor" :class="ui.textSubheading"
                  v-else>
                    Not Selected
                  </v-chip>
                </v-layout>
                <v-layout class="text-xs-left ml-2 mr-2 hidden-sm-and-up">
                  <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                    <v-avatar>
                      <v-icon> place </v-icon>
                    </v-avatar>
                    {{getUser.pref.select.fname}}
                  </v-chip>
                </v-layout>
              </div>
              <v-layout class="text-xs-left ml-2 mr-2 hidden-xs-only">
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <v-avatar>
                  <v-icon> settings </v-icon>
                  </v-avatar>
                  Request
                </v-chip>
                <v-spacer/>
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  {{localForm.title}}
                </v-chip>
              </v-layout>
              <v-layout class="text-xs-left ml-2 mr-2 hidden-sm-and-up">
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <v-avatar>
                  <v-icon> settings </v-icon>
                  </v-avatar>
                  {{localForm.title}}
                </v-chip>
              </v-layout>
              <v-layout class="text-xs-left ml-2 mr-2 hidden-sm-and-up">
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <v-avatar>
                  <v-icon> title </v-icon>
                  </v-avatar>
                  {{localForm.name}}
                </v-chip>
              </v-layout>
              <div v-if="engAsset.title !== ''">
                <v-layout class="text-xs-left ml-2 mr-2 hidden-xs-only">
                  <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                    <v-avatar>
                    <v-icon> emoji_transportation </v-icon>
                    </v-avatar>
                    Asset Name
                  </v-chip>
                  <v-spacer/>
                  <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                    {{engAsset.title}}
                  </v-chip>
                </v-layout>
                <v-layout class="text-xs-left ml-2 mr-2 hidden-sm-and-up">
                  <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                    <v-avatar>
                    <v-icon> emoji_transportation </v-icon>
                    </v-avatar>
                    {{engAsset.title}}
                  </v-chip>
                </v-layout>
                <v-layout class="text-xs-left ml-2 mr-2 hidden-xs-only">
                  <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                    <v-avatar>
                    <v-icon> fingerprint </v-icon>
                    </v-avatar>
                    Asset Tag
                  </v-chip>
                  <v-spacer/>
                  <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                    {{engAsset.id}}
                  </v-chip>
                </v-layout>
                <v-layout class="text-xs-left ml-2 mr-2 hidden-sm-and-up">
                  <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                    <v-avatar>
                    <v-icon> fingerprint </v-icon>
                    </v-avatar>
                    {{engAsset.id}}
                  </v-chip>
                </v-layout>
              </div>
              <v-layout class="text-xs-left ml-2 mr-2 hidden-xs-only"
              v-if="this.engTitlePrefix !== 'Facility'">
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <v-avatar>
                  <v-icon> filter_list </v-icon>
                  </v-avatar>
                  Level
                </v-chip>
                <v-spacer/>
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  {{localForm.reach}}
                </v-chip>
              </v-layout>
              <v-layout class="text-xs-left ml-2 mr-2 hidden-sm-and-up">
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <v-avatar>
                  <v-icon> filter_list </v-icon>
                  </v-avatar>
                  {{localForm.reach}}
                </v-chip>
              </v-layout>
              <v-layout class="text-xs-left ml-2 mr-2 hidden-xs-only">
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <v-avatar>
                  <v-icon> grid_view </v-icon>
                  </v-avatar>
                  Request
                </v-chip>
                <v-spacer/>
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  {{localForm.type}}
                </v-chip>
              </v-layout>
              <v-layout class="text-xs-left ml-2 mr-2 hidden-sm-and-up">
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <v-avatar>
                  <v-icon> grid_view </v-icon>
                  </v-avatar>
                  {{localForm.type}}
                </v-chip>
              </v-layout>
              <v-layout class="text-xs-left ml-2 mr-2 hidden-xs-only">
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <v-avatar>
                  <v-icon> engineering </v-icon>
                  </v-avatar>
                  Discipline
                </v-chip>
                <v-spacer/>
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  {{localForm.dis}}
                </v-chip>
              </v-layout>
              <v-layout class="text-xs-left ml-2 mr-2 hidden-sm-and-up">
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <v-avatar>
                  <v-icon> engineering </v-icon>
                  </v-avatar>
                  {{localForm.dis}}
                </v-chip>
              </v-layout>
              <v-layout class="text-xs-left ml-2 mr-2">
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <v-avatar>
                  <v-icon> short_text </v-icon>
                  </v-avatar>
                  Description
                </v-chip>
                <v-spacer/>
              </v-layout>
              <v-layout class="text-xs-left ml-4 mr-2 mt-2">
                <div :class="ui.textSubheading">
                  {{localForm.des}}
                </div>
              </v-layout>
            </v-container>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn
          @click="dialog = false" :color="ui.btnColor" flat>
            <v-icon left> exit_to_app </v-icon>
            Close
          </v-btn>
          <v-btn :disabled="!this.step > 0"
          class="hidden-xs-only"
          @click="previousStep(step)" :color="ui.btnColor" flat>
            <v-icon left> navigate_before </v-icon>
            Back
          </v-btn>
          <v-btn :disabled="!this.step > 0"
          class="hidden-sm-and-up"
          @click="previousStep(step)" :color="ui.btnColor" flat>
            <v-icon> navigate_before </v-icon>
          </v-btn>
          <v-spacer/>
          <v-btn :disabled="!valid" v-if="this.step < 4 && this.enableNextBtn"
          @click="nextStep(step)" :color="ui.btnColor" flat
          class="hidden-xs-only">
            Next
            <v-icon right> navigate_next </v-icon>
          </v-btn>
          <v-btn :disabled="!valid" v-if="this.step < 4 && this.enableNextBtn"
          @click="nextStep(step)" :color="ui.btnColor" flat
          class="hidden-sm-and-up"
          >
            <v-icon> navigate_next </v-icon>
          </v-btn>
          <v-btn :disabled="!valid"
          v-if="enableSubmit"
          class="hidden-xs-only"
          @click="createEngineeringRequest()" :color="ui.colorWarning" flat>
            <v-icon left> add </v-icon>
            Submit
          </v-btn>
          <v-btn :disabled="!valid"
          class="hidden-sm-and-up"
          v-if="enableSubmit"
          @click="createEngineeringRequest()" :color="ui.colorWarning" flat>
            <v-icon> add </v-icon>
          </v-btn>
          <BtnSpin :btnSpec="btnInfo1" v-if="btnSpinChangeDetail === true"/>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import BtnSpin from "@/frame/animation/components/BtnSpin";
import storeFunctions from "@/data/functions/mixins/storeFunctions.js";
import ruleTextfield from "@/data/rules/mixins/rulesTextfield.js";
import docRevsModFunctions from "@/document/revisions/mixins/docRevsModFunctions.js";
import changeDetail from "@/support/detail/mixins/changeDetail.js";
import apptheme from "@/frame/theme/mixins/apptheme.js";
import createFirebase from "@/data/cloud/firebase/mixins/createFirebase.js";
import adminFunctions from "@/admin/functions/mixins/adminFunctions.js";
import generateForms from "@/data/functions/mixins/generateForms.js";
import generateID from "@/data/cloud/firebase/mixins/generateID.js";
import relationshipsFunctions from "@/data/functions/mixins/relationshipsFunctions.js";
import executionOptions from "@/data/options/mixins/executionOptions.js";
import moment from "moment";
import getData from "@/data/cloud/firebase/mixins/getData.js";
import transFunctions from "@/support/transitions/mixins/transFunctions.js";
import relps from "@/data/forms/mixins/relps.js";
import businessOptions from "@/data/options/mixins/businessOptions.js";
import techOptions from "@/data/options/mixins/techOptions.js";
import Append from "@/data/append/components/Append";
import { mapGetters } from "vuex";

export default {
  components: {
    Append,
    BtnSpin
  },
  // eslint-disable-next-line
  mixins: [
    getData,
    apptheme,
    adminFunctions,
    docRevsModFunctions,
    createFirebase,
    ruleTextfield,
    storeFunctions,
    changeDetail,
    techOptions,
    relationshipsFunctions,
    generateID,
    generateForms,
    transFunctions,
    executionOptions,
    relps,
    businessOptions
  ],
  props: {
    data: {
      type: Object
    }
  },
  beforeMount() {
    if (this.getOriginal !== null && this.getOriginal !== undefined) {
      this.localForm.title = this.getOriginal.basic.title;
    }
  },
  data() {
    return {
      dialog: false,
      btnSpinChangeDetail: false,
      valid: true,
      btnInfo1: {
        color: "red",
        icon: "person",
        name: "add user"
      },
      indeterminateProgressBar: false,
      step: 0,
      localForm: {
        title: "",
        des: "",
        type: "Study",
        reach: "Company",
        dis: "General"
      },
      info: [
        {
          step: 0,
          title: "Engineering Study",
          // eslint-disable-next-line
          msg: "Create technical query request to support operations, maintenance or project. Define likely engineering discipline required to complete the analysis and provide trusted engineering recommendation to the business.",
          icon: ""
        },
        {
          step: 1,
          title: "Engineering Info",
          // eslint-disable-next-line
          msg: "Describe study scope which could range from companywide operations to individual machine component specific to site. In addition, select engineering study type, typically a deviation from operating procedures, risk assessment or engineering modifications.",
          icon: ""
        },
        {
          step: 2,
          title: "Verify and Submit",
          // eslint-disable-next-line
          msg: "Verify entered information. If you need to edit then return to previous steps.",
          error: "",
          icon: ""
        }
      ]
    };
  },
  computed: {
    // eslint-disable-next-line
    ...mapGetters([
      "getUser",
      "getFacility",
      "getCurrentPage",
      "getOriginal",
      "getRegisterInfo"
    ]),
    engFacility() {
      let obj = {
        enabled: false,
        fdid: this.getUser.pref.select.fdid,
        fid: this.getUser.pref.select.fid,
        fidg: this.getUser.pref.select.fidg,
        ft: this.getUser.pref.select.fname,
        ftag: "F1"
      };
      if (this.data.reach !== null && this.data.reach !== undefined) {
        if (this.data.reach === "facility") {
          obj.enabled = true;
          obj.fid = 1;
          obj.id = 2;
        }
      }
      return obj;
    },
    engAsset() {
      let obj = {
        title: "",
        id: ""
      };
      if (this.data.info !== undefined && this.data.info !== null) {
        obj.title = this.data.info.basic.title;
        obj.id = this.data.info.basic.id;
      } else if (
        this.getDetailBasic !== null &&
        this.getDetailBasic.tag === "A1"
      ) {
        obj.title = this.getDetailBasic.title;
        obj.id = this.getDetailBasic.id;
      } else if (this.getDetailLink !== null && this.getDetailLink !== null) {
        if (this.getDetailLink.at !== "") {
          obj.title = this.getDetailLink.at;
          obj.id = this.getDetailLink.aid;
        }
      } else {
        if (this.getDetailBasic !== null && this.getDetailBasic !== undefined) {
          if (this.getDetailBasic.tag === "A1") {
            obj.title = this.getDetailBasic.title;
            obj.id = this.getDetailBasic.id;
          }
        }
      }
      return obj;
    },
    btnMain() {
      let obj = {
        icon: "",
        title: ""
      };
      if (this.getCurrentPage === "/registerlist") {
        obj.icon = "settings";
        obj.title = "eng";
      } else if (this.getCurrentPage !== "/opsdetail") {
        obj.icon = "add";
        obj.title = "new";
      } else {
        obj.icon = "settings";
        obj.title = "engineering";
      }
      return obj;
    },
    stepInfo() {
      return this.info[this.step];
    },
    enableSubmit() {
      let logic = false;
      if (this.step === 2 && this.btnSpinChangeDetail === false) {
        logic = true;
      } else if (this.btnSpinChangeDetail === true) {
        logic = false;
      } else {
        logic = false;
      }
      return logic;
    },
    enableNextBtn() {
      let logic = false;
      if (this.step == 0 && this.localForm.title !== "") {
        logic = true;
      } else if (
        this.step == 1 &&
        this.localForm.reach !== "" &&
        this.localForm.type !== "" &&
        this.localForm.dis !== "" &&
        this.localForm.des !== ""
      ) {
        logic = true;
      } else {
        logic = false;
      }
      return logic;
    },
    engTitlePrefix() {
      let title = null;
      if (this.getCurrentPage === "/facilitydashengineering") {
        title = "Facility";
      } else if (this.getCurrentPage === "/facilitydash") {
        title = "Facility";
      } else if (this.getCurrentPage === "/companydashtechnical") {
        title = "Company";
      } else if (
        this.getRegisterInfo !== null &&
        this.getRegisterInfo.tag === "F1"
      ) {
        title = "Facility";
      } else {
        title = "Company";
      }
      return title;
    }
  },
  methods: {
    nextStep(step) {
      this.step = step + 1;
    },
    previousStep(step) {
      this.step = step - 1;
    },
    openDialog() {
      this.dialog = true;
      this.step = 0;
      this.btnSpinReadResult = false;
      this.btnSpinChangeDetail = false;
      this.localForm.title = "";
      this.localForm.des = "";
    },
    closeDialog() {
      this.btnSpinReadResult = false;
    },
    createEngineeringRequest() {
      this.btnSpinChangeDetail = true;
      // SET data source
      // SET data source
      const tag = "E2";
      const did = this.generateDID("DATE", tag);
      const idg = this.generateIDG("date-gid");

      // GENERATE form
      let temp = this.generateEngineeringForm(); // form is from compnew component

      // BASIC
      temp.basic.did = did;
      temp.basic.idg = idg;
      temp.basic.tag = tag;
      temp.basic.act = true; // set to true
      temp.basic.title = this.localForm.title;
      // temp.basic.id = this.localForm.tag;

      // CHAR
      temp.char.des = this.localForm.des;
      temp.char.type = this.localForm.type;
      temp.char.dis = this.localForm.dis;
      temp.char.reach = this.localForm.reach;

      // STATS
      temp.stats.dcrt = moment().format();

      // REV
      temp.rev = this.generateInitialDocumentRev(tag);
      // eslint-disable-next-line
      temp.stats.drev = moment().add(2, 'months').format();
      // eslint-disable-next-line
      temp.stats.ddue = moment().add(3, 'months').format();
      // eslint-disable-next-line
      temp.stats.dstr = moment().add(1, 'years').format();
      // eslint-disable-next-line
      temp.stats.dend = moment().add(2, 'years').format();


      // FACILITY LINK data
      if (this.engTitlePrefix === "Facility") {
        temp.char.reach = "Facility";
        let select = this.getUser.pref.select;
        temp.link.fdid = select.fdid;
        temp.link.ft = select.fname;
        temp.link.fid = select.fid;
        temp.link.fidg = select.fidg;
      }

      console.log("HELP");
      console.log(this.data.info);
      console.log(this.localForm);

      // ASSET LINK DATA
      if (
        this.data.info !== undefined &&
        this.data.info !== null &&
        this.data.info.basic.tag === "A1"
      ) {
        temp.link.adid = this.data.info.basic.did;
        temp.link.aid = this.data.info.basic.id;
        temp.link.aidg = this.data.info.basic.idg;
        temp.link.at = this.data.info.basic.title;
        temp.link.atag = this.data.info.basic.tag;
      } else if (
        this.getDetailBasic !== null &&
        this.getDetailBasic !== undefined &&
        this.getDetailBasic.tag === "A1"
      ) {
        temp.link.adid = this.getDetailBasic.did;
        temp.link.aid = this.getDetailBasic.id;
        temp.link.aidg = this.getDetailBasic.idg;
        temp.link.at = this.getDetailBasic.title;
        temp.link.atag = this.getDetailBasic.tag;
      } else if (
        this.getDetailLink !== null &&
        this.getDetailLink !== undefined
      ) {
        temp.link = this.getDetailLink;
      } else {
        // NONE
        // temp.link.adid = this.localForm.adid;
        // temp.link.aid = this.localForm.aid;
        // temp.link.aidg = this.localForm.aidg;
        // temp.link.at = this.localForm.at;
        // temp.link.atag = this.localForm.atag;
      }

      // TRANS
      let trans = this.generateInitalTransition(tag); // model
      temp.trans = trans;

      // CREATE DOC ONLY
      this.createFirebaseDocumentOnly(temp);

      // HELP
      console.log("NEW Engineering Request");
      console.log(temp);
    }
  }
};
</script>
